import PropTypes from 'prop-types'
import { Button, Card, Form } from 'antd'

import loginFields from './loginFields'
import FormField from '../shared/FormField'

const LoginForm = ({ current, send, redirectUrl }) => {
  const {
    value,
    context: { formData, errorMessage },
  } = current

  const isLoading = value === 'loading'

  return (
    <>
      <p className="text-xl font-medium text-gray-700 my-2">
        Login to DPOinBox
      </p>

      <p>
        Current State:
        {value}
      </p>

      <Card className="min-w-400">
        <p className="text-center text-red-500">{errorMessage}</p>
        <Form
          layout="vertical"
          initialValues={formData}
          onFinish={(payload) => {
            send('LOGIN', { ...payload, redirectUrl })
          }}
        >
          {loginFields.map(({ key, ...fieldAttributes }) => (
            <FormField key={`loginField-${key}`} {...fieldAttributes} />
          ))}

          <Form.Item>
            <Button type="primary" block htmlType="submit" loading={isLoading}>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </>
  )
}

LoginForm.propTypes = {
  send: PropTypes.func,
  current: PropTypes.object,
  redirectUrl: PropTypes.string,
}

export default LoginForm
